export default __webpack_public_path__ + "static/ca-d72057feba4dd447b46932c302d90117.svg";